export default __webpack_public_path__ + "static/media/default.549a36d1.svg";